import { render, staticRenderFns } from "./violationRecordDetails.vue?vue&type=template&id=2c533fc8&scoped=true"
import script from "./violationRecordDetails.vue?vue&type=script&lang=js"
export * from "./violationRecordDetails.vue?vue&type=script&lang=js"
import style0 from "./violationRecordDetails.vue?vue&type=style&index=0&id=2c533fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c533fc8",
  null
  
)

export default component.exports